import {
  getHomeBanners,
  getHomeNews,
  getHomeLinks,
  gotHomeCampusRecruiting
} from '~api/home'

export const state = () => ({
  banners: [],
  news: [],
  links: [],
  campusRecruitments: []
})

export const getters = {
  getBanners: state => state.banners,
  getNews: state => state.news,
  getLinks: state => state.links,
  getCampusRecruitments: state => state.campusRecruitments
}

export const actions = {
  async getHomeBannerData ({ commit }) {
    const data = await getHomeBanners()
    commit('HOME_BANNER_DATA_GET_SUCCESS', data)
  },
  async getHomeNewsData ({ commit }) {
    const data = await getHomeNews()
    commit('HOME_NEWS_DATA_GET_SUCCESS', data)
  },
  async getHomeLinkData ({ commit }) {
    const data = await getHomeLinks()
    commit('HOME_LINK_DATA_GET_SUCCESS', data)
  },
  async getHomeCampusRecruitingData ({ commit }) {
    const data = await gotHomeCampusRecruiting()
    commit('HOME_CAMPUs_RECRUITING_DATA_GET_SUCCESS', data)
  }
}

export const mutations = {
  HOME_BANNER_DATA_GET_SUCCESS (state, payload) {
    state.banners = payload
  },
  HOME_NEWS_DATA_GET_SUCCESS (state, payload) {
    state.news = payload
  },
  HOME_LINK_DATA_GET_SUCCESS (state, payload) {
    state.links = payload
  },
  HOME_CAMPUs_RECRUITING_DATA_GET_SUCCESS (state, payload) {
    state.campusRecruitments = payload
  }
}
